import type { ListOutgoingTransfersData } from '@peanuds/shared';

import {
  DEFAULT_LIMIT,
  DEFAULT_OFFSET,
  DEFAULT_TRANSFER_DATE_FROM,
} from './transactions.request-options';

export type PaymentsApprovalFetchOptions = {
  transferDateFrom?: string;
  transferDateTo?: string;
  pageNumber?: number;
  pageSize?: number;
  limit?: number;
  offset?: number;
  outgoingQuery?: Partial<ListOutgoingTransfersData['query']>;
};

export const PAYMENTS_APPROVAL_FETCH_OPTIONS = {
  transferDateFrom: DEFAULT_TRANSFER_DATE_FROM,
  limit: DEFAULT_LIMIT,
  offset: DEFAULT_OFFSET,
} as const;
